module.exports = __webpack_public_path__ + "media/images/homepage/slider3-aba0d7cf82a6903d2b382a7855e229c8.png";